import React, { useState } from "react";
import "./BankTransfer15to24.css";
import {
  handleTransferApi,
  handleTransferApi15to16,
  handleTransferApi15to17,
  handleTransferApi15to18,
  handleTransferApi16to19,
  handleTransferApi16to20,
  handleTransferApi17to21,
  handleTransferApi17to22,
  handleTransferApi18to23,
  handleTransferApi18to24,
  markFraud,
} from "./services/apinew"; // Import the API function
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useEffect } from "react";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa"; // Import the required icons
import { fetchCount, fetchTimeTaken } from "./services/apinew";
import { handleTruncateApi, handleInsertApi } from "./services/apinew";
import Panic from "./panic.png";
import { useNavigate } from "react-router-dom";

const BankTransfer15to24 = () => {
  const [amount, setAmount] = useState("1,000"); // Prefill amount with 1000
  const [tag15, setTag15] = useState(""); // State to hold tag5 from response
  const [tag4, setTag4] = useState("");
  const [amountTransferred15, setAmountTransferred15] = useState(""); // State for amountTransferred5
  const [amountTransferred16, setAmountTransferred16] = useState(""); // State for amountTransferred5
  const [amountTransferred17, setAmountTransferred17] = useState(""); // State for amountTransferred5
  const [amountTransferred18, setAmountTransferred18] = useState(""); // State for amountTransferred5
  const [amountTransferred19, setAmountTransferred19] = useState(""); // State for amountTransferred5
  const [amountTransferred20, setAmountTransferred20] = useState(""); // State for amountTransferred5
  const [amountTransferred21, setAmountTransferred21] = useState(""); // State for amountTransferred5
  const [amountTransferred22, setAmountTransferred22] = useState(""); // State for amountTransferred5
  const [amountTransferred23, setAmountTransferred23] = useState(""); // State for amountTransferred5
  const [amountTransferred24, setAmountTransferred24] = useState(""); // State for amountTransferred5
  const [isTransactionSuccessful, setIsTransactionSuccessful] = useState(false);
  const [amount1, setAmount1] = useState("1,00,000"); // Prefill amount with 1000
  const [amount2, setAmount2] = useState("50,000"); // Prefill amount with 1000
  const [amount3, setAmount3] = useState("30,000"); // Prefill amount with 1000
  const [amount4, setAmount4] = useState("25,000"); // Prefill amount with 1000
  const [amount5, setAmount5] = useState("25,000"); // Prefill amount with 1000
  const [amount6, setAmount6] = useState("30,000"); // Prefill amount with 1000
  const [amount7, setAmount7] = useState("25,000"); // Prefill amount with 1000
  const [amount8, setAmount8] = useState("20,000"); // Prefill amount with 1000
  const [amount9, setAmount9] = useState("10,000"); // Prefill amount with 1000
  const [amount10, setAmount10] = useState("1,000"); // Prefill amount with 1000
  const [amount11, setAmount11] = useState("1,000"); // Prefill amount with 1000
  const [amount12, setAmount12] = useState("1,000"); // Prefill amount with 1000
  const [amount13, setAmount13] = useState("1,000"); // Prefill amount with 1000
  const [amount14, setAmount14] = useState("1,000"); // Prefill amount with 1000
  const [amount15, setAmount15] = useState("1,000"); // Prefill amount with 1000
  const [tag16, setTag16] = useState(""); // State to show API response
  const [tag17, setTag17] = useState(""); // State to show API response
  const [isTransactionSuccessful15, setIsTransactionSuccessful15] =
    useState(false); // State for Bank 5 Transaction Success
  const [isTransactionSuccessful15to17, setIsTransactionSuccessful15to17] =
    useState(false);
  const [isTransactionSuccessful15to18, setIsTransactionSuccessful15to18] =
    useState(false);
  const [isTransactionSuccessful16to19, setIsTransactionSuccessful16to19] =
    useState(false);
  const [isTransactionSuccessful16to20, setIsTransactionSuccessful16to20] =
    useState(false);
  const [isTransactionSuccessful17to21, setIsTransactionSuccessful17to21] =
    useState(false);
  const [isTransactionSuccessful17to22, setIsTransactionSuccessful17to22] =
    useState(false);
  const [isTransactionSuccessful18to23, setIsTransactionSuccessful18to23] =
    useState(false);
  const [isTransactionSuccessful18to24, setIsTransactionSuccessful18to24] =
    useState(false);
  const [tag18, setTag18] = useState(""); // State to show API response
  const [tag19, setTag19] = useState(""); // State to show API response
  const [tag20, setTag20] = useState(""); // State to show API response
  const [tag21, setTag21] = useState(""); // State to show API response
  const [tag22, setTag22] = useState(""); // State to show API response
  const [tag23, setTag23] = useState(""); // State to show API response
  const [tag24, setTag24] = useState(""); // State to show API response
  const [panicMessage, setPanicMessage] = useState("");
  const [count, setCount] = useState(null);
  const [timeDifference, setTimeDifference] = useState(null);
  const [status, setStatus] = useState(null);
  const [status1, setStatus1] = useState(null);
  const [loading, setLoading] = useState(false); // Loader state for Truncate API
  const [loading1, setLoading1] = useState(false); // Loader state for Insert API
  const [tagvalidity, setTagValidity] = useState(0); // Initialize with 0
  const [panicMessage15, setPanicMessage15] = useState(null);
  const [panicMessage16, setPanicMessage16] = useState(null);
  const [panicMessage17, setPanicMessage17] = useState(null);
  const [panicMessage18, setPanicMessage18] = useState(null);
  const [panicMessage19, setPanicMessage19] = useState(null);
  const [panicMessage20, setPanicMessage20] = useState(null);
  const [panicMessage21, setPanicMessage21] = useState(null);
  const [panicMessage22, setPanicMessage22] = useState(null);
  const [panicMessage23, setPanicMessage23] = useState(null);
  const [panicMessage24, setPanicMessage24] = useState(null);

  useEffect(() => {
    document.title = "TAGER AI-Bank15to24"; // Set the page title for this route
  }, []);

  // Fetch the data when the component is mounted and periodically after every interval
  // Fetch the data when the component is mounted and periodically after every interval
  useEffect(() => {
    const fetchCountData = async () => {
      try {
        const count = await fetchCount();
        setCount(count);
        // Re-fetch after the first response
        setTimeout(fetchCountData, 1000);
      } catch (error) {
        console.error("Error fetching count:", error);
      }
    };

    fetchCountData();
  }, []);

  useEffect(() => {
    const fetchTimeTakenData = async () => {
      try {
        const timeDifference = await fetchTimeTaken();
        setTimeDifference(timeDifference);
        // Re-fetch after the first response
        setTimeout(fetchTimeTakenData, 1000);
      } catch (error) {
        console.error("Error fetching time taken:", error);
      }
    };

    fetchTimeTakenData();
  }, []);

   const navigate = useNavigate(); // Initialize useNavigate hook

   const handleLogout = () => {
     // Clear login status from localStorage
     localStorage.removeItem("isLoggedIn");

     // Notify other tabs about logout
     localStorage.setItem("logout-event", Date.now());

     // Redirect to LoginPage (forces reload in all tabs)
     window.location.href = "/";
   };


  const formatNumberWithCommas = (value) => {
    // Remove all non-numeric characters (to handle user input correctly)
    value = value.replace(/[^0-9]/g, "");

    // First handle Indian number system for lakh, crore, etc.
    if (value.length > 3) {
      let lastThree = value.slice(-3); // Get the last three digits
      let otherNumbers = value.slice(0, value.length - 3); // Get the rest of the number

      // Format the first part using comma every two digits
      otherNumbers = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",");

      // Join the formatted parts
      return otherNumbers + "," + lastThree;
    }

    // If the number is less than 1000, just return the value (without commas)
    return value;
  };

  // Function to remove commas from a formatted number
  const removeCommas = (value) => {
    return value.replace(/,/g, "");
  };

  const handleAmountChange = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount(formattedValue);
  };
  const handleAmountChange15 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount1("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount1(formattedValue);
  };
  const handleAmountChange15to17 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount2("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount2(formattedValue);
  };
  const handleAmountChange15to18 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount3("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount3(formattedValue);
  };
  const handleAmountChange16to19 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount4("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount4(formattedValue);
  };
  const handleAmountChange16to20 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount5("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount5(formattedValue);
  };
  const handleAmountChange17to21 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount6("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount6(formattedValue);
  };
  const handleAmountChange17to22 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount7("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount7(formattedValue);
  };
  const handleAmountChange18to23 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount8("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount8(formattedValue);
  };
  const handleAmountChange18to24 = (e) => {
    // Remove non-numeric characters and commas
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    // Check if the numeric value is 0
    if (numericValue === "0") {
      // Set an empty string or show a warning
      setAmount9("");
      alert("The minimum transaction amount should be 1");
      return;
    }

    // Format the numeric value with commas
    const formattedValue = formatNumberWithCommas(numericValue);

    // Update the amount state
    setAmount9(formattedValue);
  };

  const handleTransfer = async () => {
    if (!amount) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi(amount);

      setTag4(data.tag4);
      setTag15(data.tag15); // Set tag5 from the API response

      setAmountTransferred15(data.amountTransferred15);
      setIsTransactionSuccessful(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer15to16 = async () => {
    if (!amount1) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi15to16(amount1);

      // Retain the old tag5 data and only set tag6 from the API response

      if (
        data.tag16 == "1B15B16" ||
        data.tag16 == "2B15B16" ||
        data.tag16 == "3B15B16"
      ) {
        setPanicMessage16("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      setTag16(data.tag16); // Set tag6 from the API response
      setAmountTransferred16(data.amountTransferred16);
      setIsTransactionSuccessful15(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer15to17 = async () => {
    if (!amount2) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi15to17(amount2);
      if (
        data.tag16 == "1B15B17" ||
        data.tag16 == "2B15B17" ||
        data.tag16 == "3B15B17"
      ) {
        setPanicMessage17("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag17(data.tag17); // Set tag6 from the API response
      setAmountTransferred17(data.amountTransferred17);
      setIsTransactionSuccessful15to17(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer15to18 = async () => {
    if (!amount3) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi15to18(amount3);
      if (data.tag18 == "3B15B18") {
        setPanicMessage18("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag18(data.tag18); // Set tag6 from the API response
      setAmountTransferred18(data.amountTransferred18);
      setIsTransactionSuccessful15to18(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer16to19 = async () => {
    if (!amount4) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi16to19(amount4);
      if (
        data.tag19 == "1B15B16" ||
        data.tag19 == "2B15B16" ||
        data.tag19 == "3B15B16"
      ) {
        setPanicMessage19("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag19(data.tag19); // Set tag6 from the API response
      setAmountTransferred19(data.amountTransferred19);
      setIsTransactionSuccessful16to19(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer16to20 = async () => {
    if (!amount5) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi16to20(amount5);
      if (
        data.tag20 == "1B15B16" ||
        data.tag20 == "2B15B16" ||
        data.tag20 == "3B15B16"
      ) {
        setPanicMessage20("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag20(data.tag20); // Set tag6 from the API response
      setAmountTransferred20(data.amountTransferred20);
      setIsTransactionSuccessful16to20(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer17to21 = async () => {
    if (!amount6) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi17to21(amount6);
      if (
        data.tag21 == "1B15B17" ||
        data.tag21 == "2B15B17" ||
        data.tag21 == "3B15B17"
      ) {
        setPanicMessage21("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag21(data.tag21); // Set tag6 from the API response
      setAmountTransferred21(data.amountTransferred21);
      setIsTransactionSuccessful17to21(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer17to22 = async () => {
    if (!amount7) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi17to22(amount7);
      if (
        data.tag22 == "1B15B17" ||
        data.tag22 == "2B15B17" ||
        data.tag22 == "3B15B17"
      ) {
        setPanicMessage22("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }
      // Retain the old tag5 data and only set tag6 from the API response
      setTag22(data.tag22); // Set tag6 from the API response
      setAmountTransferred22(data.amountTransferred22);
      setIsTransactionSuccessful17to22(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer18to23 = async () => {
    if (!amount8) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi18to23(amount8);
      if (data.tag23 == "3B15B18") {
        setPanicMessage23("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag23(data.tag23); // Set tag6 from the API response
      setAmountTransferred23(data.amountTransferred23);
      setIsTransactionSuccessful18to23(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handleTransfer18to24 = async () => {
    if (!amount9) {
      alert("Please enter an amount.");
      return;
    }

    try {
      // Call the API function from the utils file
      const data = await handleTransferApi18to24(amount9);
      if (data.tag24 == "3B15B18") {
        setPanicMessage24("Blocked");
      }
      // Set tag validity from API response
      if (data.tagvalidity) {
        setTagValidity(data.tagvalidity);
      }

      // Retain the old tag5 data and only set tag6 from the API response
      setTag24(data.tag24); // Set tag6 from the API response
      setAmountTransferred24(data.amountTransferred24);
      setIsTransactionSuccessful18to24(true); // Mark the transaction as successful
      console.log(data);
    } catch (error) {
      console.error("Error during transfer:", error);
    }
  };
  const handlePanicButtonClick = async (part1Value) => {
    try {
      // Only proceed if part1Value matches one of the tags
      const matchedTag = [
        tag15,
        tag16,
        tag17,
        tag18,
        tag19,
        tag20,
        tag21,
        tag22,
        tag23,
        tag24,
      ].some((tag) => tag.split("-")[0] === part1Value);

      if (matchedTag) {
        const data = await markFraud(part1Value); // Call the API function

        if (data) {
          // Dynamically set the panic message based on part1Value
          switch (part1Value) {
            case "1B15B16":
            case "2B15B16": // OR condition for 1B15B16 and 2B15B16
              setPanicMessage15(data.message);
              setPanicMessage18(data.message);
              setPanicMessage20(data.message);
              setPanicMessage19(data.message);
              setPanicMessage16(data.message); // Also set for 2B15B16
              break;
            case "3B15B16": // Added case for 3B15B16
              setPanicMessage16(data.message); // Set panic message for 3B15B16
              setPanicMessage23(data.message);
              setPanicMessage24(data.message);
              setPanicMessage19(data.message);
              setPanicMessage20(data.message);
              break;

            case "2B15B17":
              setPanicMessage17(data.message);
              setPanicMessage21(data.message);
              setPanicMessage22(data.message);
              break;
            case "3B15B18":
              setPanicMessage16(data.message);
              setPanicMessage23(data.message);
              setPanicMessage24(data.message);
              break;
            case "2B15B20":
              setPanicMessage19(data.message);
              break;
            case "3B15B21":
              setPanicMessage20(data.message);
              break;
            case "1B15B22":
              setPanicMessage21(data.message);
              break;
            case "2B15B23":
              setPanicMessage22(data.message);
              break;
            case "3B15B24":
              setPanicMessage23(data.message);
              break;
            case "3B15B17": // Added case for 3B15B16
              setPanicMessage17(data.message);
              setPanicMessage21(data.message);
              setPanicMessage22(data.message);
              break;
            case "1B15B17": // Added case for 3B15B16
              setPanicMessage17(data.message);
              setPanicMessage21(data.message);
              setPanicMessage22(data.message);
              break;
            case "1B15B16":
              setPanicMessage19(data.message);
              setPanicMessage20(data.message);
            default:
              break;
          }
        }
      } else {
        console.warn("No tag matched the provided part1Value:", part1Value);
      }
    } catch (error) {
      console.error("Error occurred while calling API:", error);
    }
  };


  // Function to reset all panic messages
  const resetPanicMessages = () => {
    setPanicMessage15(null);
    setPanicMessage16(null);
    setPanicMessage17(null);
    setPanicMessage18(null);
    setPanicMessage19(null);
    setPanicMessage20(null);
    setPanicMessage21(null);
    setPanicMessage22(null);
    setPanicMessage23(null);
    setPanicMessage24(null);
  };

  

  // Function to call the truncate API
  // Usage example for truncate operation
  const handleTruncate = async () => {
    setLoading(true); // Show loader
    try {
      const status = await handleTruncateApi();
      setStatus(status);
      setTimeout(() => setStatus(null), 1000);
      setTagValidity(0); // Reset Tag Validity to 0
    } catch (error) {
      console.error("Error during truncate operation:", error);
    } finally {
      setLoading(false); // Hide loader
    }
  };

  // Usage example for insert operation
  const handleInsert = async () => {
    setLoading1(true); // Show loader
    try {
      const status1 = await handleInsertApi();
      setStatus1(status1);
      setTimeout(() => setStatus1(null), 1000);
    } catch (error) {
      console.error("Error during insert operation:", error);
    } finally {
      setLoading1(false); // Hide loader
    }
  };
 

  return (
    <>
      <h1 className="main-title">
        Fraud Modus Operandi 2
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </h1>
      <div className="bank-wrapper1">
        {/* Horizontal Container for Bank 4 and Bank 5 */}
        <div className="horizontal-bank-container">
          {/* Bank4 Container */}
          {/* <div className="bank-label">Bank 25</div>
        <div className="tag-label25">Tager code 25</div> */}

          {/* <div className="bank-container bank4-container">
          {isTransactionSuccessful ? (
            <div className="transaction-success-message">
              Transaction successful!
            </div>
          ) : (
            <div className="amount-container">
              <input
                type="text"
                className={`amount-input ${amount ? "prefilled" : ""}`}
                value={amount}
                onChange={handleAmountChange}
                style={{
                  width: "95px",
                  padding: "5px",
                  fontSize: "14px",
                  position: "relative",
                  top: "15px",
                  paddingLeft: "20px",
                  left: "5px",
                }}
              />
              
              <button className="transfer-button" onClick={handleTransfer}>
                Transfer
              </button>
            </div>
          )}
        </div>
        
        <div className="arrow-to-bank5">&#8594;</div> */}

          <div className="bank-container bank51-container">
            <div className="bank-label151">Bank 15</div> {/* Bank label */}
            <div className="tag-label121">Tager code B15</div>
            {/*  Bank transfer 5 to 6 */}
            {isTransactionSuccessful15 ? (
              <div className="transaction-success-container">
                <div className="transaction-success-message51to61">
                  <div>Transaction</div>
                  <div>successful!</div>
                </div>

                <img
                  src={Panic}
                  onClick={() => {
                    handlePanicButtonClick("1B15B16");
                    handlePanicButtonClick("2B15B16");
                    handlePanicButtonClick("3B15B16");
                  }}
                  // Only this button triggers panic message for 1B15B16
                  style={{
                    cursor: "pointer",
                    width: "35px",
                    height: "auto",
                    marginLeft: "130px", // Adjust spacing
                    marginTop: "14px",
                  }}
                  alt="Panic Button 1"
                />
              </div>
            ) : (
              <div className="amount-containernew">
                <input
                  type="text"
                  className={`amount-input ${amount1 ? "prefilled" : ""}`}
                  value={amount1}
                  onChange={handleAmountChange15}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "15px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button"
                  onClick={() => {
                    handleTransfer15to16(); // Your transfer logic
                    setIsTransactionSuccessful15(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            {/*  Bank transfer 5 to 7 */}
            {/* Dotted divider between 5 to 6 and 5 to 7 */}
            <div className="dotted-divider51to61"></div>
            {isTransactionSuccessful15to17 ? (
              <div className="transaction-success-container">
                <div className="transaction-success-message51to7">
                  <div>Transaction</div>
                  <div>successful!</div>
                </div>
                <img
                  src={Panic}
                  onClick={() => {
                    handlePanicButtonClick("1B15B17");
                    handlePanicButtonClick("2B15B17");
                    handlePanicButtonClick("3B15B17");
                  }}
                  style={{
                    cursor: "pointer",
                    width: "35px",
                    height: "auto",
                    marginLeft: "130px", // Adjust spacing to position the panic button next to the success message
                  }}
                  alt="Panic Button 2"
                />
              </div>
            ) : (
              <div className="amount-containernew">
                <input
                  type="text"
                  className={`amount-input ${amount2 ? "prefilled" : ""}`}
                  value={amount2}
                  onChange={handleAmountChange15to17}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "6px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button712"
                  onClick={() => {
                    handleTransfer15to17(); // Your transfer logic
                    setIsTransactionSuccessful15to17(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            {/*  Bank transfer 5 to 8 */}
            <div className="dotted-divider51to618"></div>
            {isTransactionSuccessful15to18 ? (
              <div className="transaction-success-container">
                <div className="transaction-success-message51to8">
                  <div>Transaction</div>
                  <div>successful!</div>
                </div>
                {/* <img
                  src={Panic}
                  onClick={() => handlePanicButtonClick("3B15B18")} // Only this button triggers panic message for 3B15B18
                  style={{
                    cursor: "pointer",
                    width: "35px",
                    height: "auto",
                    marginLeft: "130px", // Adjust spacing to position the panic button next to the success message
                    marginTop: "17px",
                  }}
                  alt="Panic Button 3"
                /> */}
              </div>
            ) : (
              <div className="amount-containernew">
                <input
                  type="text"
                  className={`amount-input ${amount3 ? "prefilled" : ""}`}
                  value={amount3}
                  onChange={handleAmountChange15to18}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "15px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button"
                  onClick={() => {
                    handleTransfer15to18(); // Your transfer logic
                    setIsTransactionSuccessful15to18(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            <div className="tag-amount-container">
              {panicMessage15 && tag15.split("-")[0] === "1B15B16" && (
                <div className="tag-response-wrapper">
                  {panicMessage15 && (
                    <div className="panic-message15">
                      {panicMessage15}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}

                  <div className="tag-response">{tag15}</div>
                  {amountTransferred15 && (
                    <div className="amount-transferred5">
                      ₹ {formatNumberWithCommas(amountTransferred15.toString())}
                    </div>
                  )}
                </div>
              )}

              {tag16 && (
                <div className="tag-response-wrapper">
                  {panicMessage16 &&
                    (tag16.split("-")[0] === "1B15B16" ||
                      tag16.split("-")[0] === "3B15B16" ||
                      tag16.split("-")[0] === "2B15B16") && (
                      <div className="panic-message188">
                        {panicMessage16}
                        <i className="fas fa-ban disabled-icon"></i>{" "}
                        {/* Disabled icon */}
                      </div>
                    )}
                  <div className="tag1611-response">{tag16}</div>
                  {amountTransferred16 && (
                    <div className="amount-transferred16">
                      ₹ {formatNumberWithCommas(amountTransferred16.toString())}
                    </div>
                  )}
                </div>
              )}

              {tag17 && (
                <div className="tag-response-wrapper">
                  {panicMessage17 &&
                    (tag17.split("-")[0] === "2B15B17" ||
                      tag17.split("-")[0] === "1B15B17" ||
                      tag17.split("-")[0] === "3B15B17") && (
                      <div className="panic-message17">
                        {panicMessage17}
                        <i className="fas fa-ban disabled-icon"></i>{" "}
                        {/* Disabled icon */}
                      </div>
                    )}

                  <div className="tag7-response">{tag17}</div>
                  {amountTransferred17 && (
                    <div className="amount-transferred7">
                      ₹ {formatNumberWithCommas(amountTransferred17.toString())}
                    </div>
                  )}
                </div>
              )}

              {tag18 && (
                <div className="tag-response-wrapper">
                  {/* {panicMessage18 && tag18.split("-")[0] === "3B15B18" && (
                    <div className="panic-message1637">
                      {panicMessage18}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                     
                    </div>
                  )} */}
                  {/* <div className="tag8212-response">{tag18}</div> */}
                  {amountTransferred18 && (
                    <div className="amount-transferred811">
                      ₹ {formatNumberWithCommas(amountTransferred18.toString())}
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="tag-responses-container">
              {/* Tag 9 */}
              {tag19 && (
                <div className="tag-response-wrapper">
                  {panicMessage19 &&
                    (tag19.split("-")[0] === "1B15B16" ||
                      tag19.split("-")[0] === "2B15B16" ||
                      tag19.split("-")[0] === "3B15B16") && (
                      <div className="panic-message191">
                        {panicMessage19}
                        <i className="fas fa-ban disabled-icon"></i>{" "}
                        {/* Disabled icon */}
                      </div>
                    )}

                  <div className="tag91-response">{tag19}</div>
                  {amountTransferred19 && (
                    <div className="amount-transferred91">
                      ₹ {formatNumberWithCommas(amountTransferred19.toString())}
                    </div>
                  )}
                </div>
              )}

              {/* Tag 10 */}
              {tag20 && (
                <div className="tag-response-wrapper">
                  {panicMessage20 &&
                    (tag20.split("-")[0] === "1B15B16" ||
                      tag20.split("-")[0] === "2B15B16" ||
                      tag20.split("-")[0] === "3B15B16") && (
                      <div className="panic-message200">
                        {panicMessage20}
                        <i className="fas fa-ban disabled-icon"></i>{" "}
                        {/* Disabled icon */}
                      </div>
                    )}

                  <div className="tag100-response">{tag20}</div>
                  {amountTransferred20 && (
                    <div className="amount-transferred100">
                      ₹ {formatNumberWithCommas(amountTransferred20.toString())}
                    </div>
                  )}
                </div>
              )}

              {/* Tag 11 */}
              {tag21 && (
                <div className="tag-response-wrapper">
                  {panicMessage21 &&
                    (tag21.split("-")[0] === "2B15B17" ||
                      tag21.split("-")[0] === "1B15B17" ||
                      tag21.split("-")[0] === "3B15B17") && (
                      <div className="panic-message211">
                        {panicMessage21}
                        <i className="fas fa-ban disabled-icon"></i>{" "}
                        {/* Disabled icon */}
                      </div>
                    )}

                  <div className="tag111-response">{tag21}</div>
                  {amountTransferred21 && (
                    <div className="amount-transferred111n">
                      ₹ {formatNumberWithCommas(amountTransferred21.toString())}
                    </div>
                  )}
                </div>
              )}

              {/* Tag 12 */}
              {tag22 && (
                <div className="tag-response-wrapper">
                  {panicMessage22 &&
                    (tag22.split("-")[0] === "2B15B17" ||
                      tag22.split("-")[0] === "1B15B17" ||
                      tag22.split("-")[0] === "3B15B17") && (
                      <div className="panic-message899">
                        {panicMessage22}
                        <i className="fas fa-ban disabled-icon"></i>{" "}
                        {/* Disabled icon */}
                      </div>
                    )}

                  <div className="tag122-response">{tag22}</div>
                  {amountTransferred22 && (
                    <div className="amount-transferred122">
                      ₹ {formatNumberWithCommas(amountTransferred22.toString())}
                    </div>
                  )}
                </div>
              )}
              {/* Tag 12 */}
              {tag23 && (
                <div className="tag-response-wrapper">
                  {panicMessage23 && tag23.split("-")[0] === "3B15B18" && (
                    <div className="panic-message900">
                      {panicMessage23}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  {/* <div className="tag133-response">{tag23}</div> */}
                  {amountTransferred23 && (
                    <div className="amount-transferred133">
                      ₹ {formatNumberWithCommas(amountTransferred23.toString())}
                    </div>
                  )}
                </div>
              )}
              {tag24 && (
                <div className="tag-response-wrapper">
                  {panicMessage24 && tag24.split("-")[0] === "3B15B18" && (
                    <div className="panic-message1001">
                      {panicMessage24}
                      <i className="fas fa-ban disabled-icon"></i>{" "}
                      {/* Disabled icon */}
                    </div>
                  )}
                  {/* <div className="tag142-response">{tag24}</div> */}
                  {amountTransferred24 && (
                    <div className="amount-transferred142">
                      ₹ {formatNumberWithCommas(amountTransferred24.toString())}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {/* Add the arrows */}
          <div className="arrow-container">
            <div className="arrow-to-bank6">&#8594;</div>
            <div className="arrow-to-bank7">&#8594;</div>
            <div className="arrow-to-bank8">&#8594;</div>
          </div>
        </div>

        {/* Vertical Bank Containers */}
        <div className="vertical-bank-container">
          <div className="vertical-bank-item">
            <div className="bank-label161">NBFC 16</div>{" "}
            {/* Added Bank label here */}
            <div className="tag-label131">Tager code B16</div>
            {/* Bank transfer 6 to 9 */}
            {isTransactionSuccessful16to19 ? (
              <div className="transaction-success-message6to9">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-containernew">
                <input
                  type="text"
                  className={`amount-input ${amount4 ? "prefilled" : ""}`}
                  value={amount4}
                  onChange={handleAmountChange16to19}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "15px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button"
                  onClick={() => {
                    handleTransfer16to19(); // Your transfer logic
                    setIsTransactionSuccessful16to19(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            {/* Bank transfer 6 to 10 */}
            <div className="dotted-divider2"></div>
            {isTransactionSuccessful16to20 ? (
              <div className="transaction-success-message6to10">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-container">
                <input
                  type="text"
                  className={`amount-input ${amount5 ? "prefilled" : ""}`}
                  value={amount5}
                  onChange={handleAmountChange16to20}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "5px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button6"
                  onClick={() => {
                    handleTransfer16to20(); // Your transfer logic
                    setIsTransactionSuccessful16to20(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
          </div>
          {/* Bank transfer 7 to 11 */}

          <div className="vertical-bank-item">
            <div className="bank-label171">Bank 17</div>{" "}
            {/* Added Bank label here */}
            {/* Bank 7 Container with Amount Input */}
            <div className="tag-label141">Tager code B17</div>
            {isTransactionSuccessful17to21 ? (
              <div className="transaction-success-message7to11">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-container">
                <input
                  type="text"
                  className={`amount-input ${amount6 ? "prefilled" : ""}`}
                  value={amount6}
                  onChange={handleAmountChange17to21}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "15px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button"
                  onClick={() => {
                    handleTransfer17to21(); // Your transfer logic
                    setIsTransactionSuccessful17to21(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            <div className="dotted-divider2"></div>
            {/* Bank transfer 7 to 12 */}
            {isTransactionSuccessful17to22 ? (
              <div className="transaction-success-message7to12">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-container">
                <input
                  type="text"
                  className={`amount-input ${amount7 ? "prefilled" : ""}`}
                  value={amount7}
                  onChange={handleAmountChange17to22}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "5px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />
                <button
                  className="transfer-button7"
                  onClick={() => {
                    handleTransfer17to22(); // Your transfer logic
                    setIsTransactionSuccessful17to22(true); // Mark transaction as successful
                  }}>
                  Transfer
                </button>
              </div>
            )}
          </div>
          {/* Bank transfer 8 to 13 */}

          <div className="vertical-bank-item">
            <div className="bank-label181">Bank 18</div>{" "}
            {/* Added Bank label here */}
            <div className="tag-label151">Tager code B18</div>
            {isTransactionSuccessful18to23 ? (
              <div className="transaction-success-message8to13">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-container">
                <input
                  type="text"
                  className={`amount-input ${amount8 ? "prefilled" : ""}`}
                  value={amount8}
                  onChange={handleAmountChange18to23}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "15px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button"
                  onClick={() => {
                    handleTransfer18to23(); // Your transfer logic
                    setIsTransactionSuccessful18to23(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            {/* Bank transfer 8 to 14 */}
            <div className="dotted-divider2"></div>
            {/* Amount Container for Bank 8 to 14 */}
            {isTransactionSuccessful18to24 ? (
              <div className="transaction-success-message8to14">
                Transaction successful!
              </div>
            ) : (
              <div className="amount-container">
                <input
                  type="text"
                  className={`amount-input ${amount9 ? "prefilled" : ""}`}
                  value={amount9}
                  onChange={handleAmountChange18to24}
                  style={{
                    width: "95px",
                    padding: "5px",
                    fontSize: "14px",
                    position: "relative",
                    top: "5px",
                    paddingLeft: "20px",
                    left: "5px",
                    fontWeight: "bold", // Make the text bold
                  }}
                />

                <button
                  className="transfer-button8"
                  onClick={() => {
                    handleTransfer18to24(); // Your transfer logic
                    setIsTransactionSuccessful18to24(true); // Set transaction success to true
                  }}>
                  Transfer
                </button>
              </div>
            )}
            {/* Panic Button */}
            <div className="button-container">
              <button
                className={`circle-button ${
                  status === "success" ? "green" : "red"
                }`}
                onClick={handleTruncate}
                disabled={loading} // Disable button while loading
              >
                {loading ? (
                  <span className="loader">...</span> // Show loader
                ) : status === "success" ? (
                  <FaCheckCircle />
                ) : null}{" "}
                {/* Show nothing if no status or loading */}
              </button>

              <button
                className={`circle-button2 ${
                  status1 === "success" ? "green" : "red"
                }`}
                onClick={handleInsert}
                disabled={loading1} // Disable button while loading
              >
                {loading1 ? (
                  <span className="loader">...</span> // Show loader
                ) : status1 === "success" ? (
                  <FaCheckCircle />
                ) : null}{" "}
                {/* Show nothing if no status or loading */}
              </button>

              {/* Panic button */}
              {/* <img
              src={Panic}
              onClick={handlePanicButtonClick}
              style={{
                cursor: "pointer",
                width: "75px", // Set desired width
                height: "auto", // Maintain aspect ratio
                position: "absolute", // To position it freely inside the container
                bottom: "40px", // Adjust placement from the bottom
                right: "12px", // Adjust placement from the right
              }}
              alt="Panic Button"
            /> */}
            </div>
            <div className="fund-movement-container">
              <div className="fund-movement">
                Fund Movement :
                <span className="red-value">
                  {count !== null ? count : "Loading..."}
                </span>
              </div>
              <div className="time-taken1">
                Time Taken:{" "}
                <span className="red-value">
                  {timeDifference !== null
                    ? `${timeDifference} `
                    : "Loading..."}
                </span>
              </div>
              <div className="withdrawal-count">
                Withdrawal Attempts: <span className="red-value">0</span>
              </div>
              <div className="tag-validity">
                Tag Validity:
                <span className="red-value">
                  {tagvalidity !== null ? `${tagvalidity}` : "0"}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="arrow-containernew">
          <div className="arrow-to-bank190">&#8594;</div>
          <div className="arrow-to-bank200">&#8594;</div>

          <div className="arrow-to-bank211"> &#8594;</div>
          <div className="arrow-to-bank222">&#8594;</div>

          <div className="arrow-to-bank233">&#8594;</div>
          <div className="arrow-to-bank244">&#8594;</div>
        </div>
        <div className="vertical-bank-container2">
          <div className="vertical-bank-item3">
            {/* Bank 9 Label */}
            <div className="bank-label191">Bank 19</div>{" "}
            {/* Added Bank 9 label here */}
            <div className="tag-label161">Tager code B19</div>
            {isTransactionSuccessful16to19 && (
              <div className="tick-iconnew">
                <i
                  className="fas fa-check-circle"
                  style={{ color: "#3385c9", fontSize: "30px" }}></i>
              </div>
            )}
          </div>
          <div className="vertical-bank-item3">
            {/* Bank 10 Label */}
            <div className="bank-label200">Bank 20</div>{" "}
            {/* Added Bank 9 label here */}
            <div className="tag-label171">Tager code B20</div>
            {isTransactionSuccessful16to20 && (
              <div className="tick-iconnew">
                <i
                  className="fas fa-check-circle"
                  style={{ color: "#3385c9", fontSize: "30px" }}></i>
              </div>
            )}
          </div>
          <div className="vertical-bank-item3">
            {/* Bank 11 Label */}
            <div className="bank-label211">Bank 21</div>{" "}
            {/* Added Bank 9 label here */}
            <div className="tag-label181">Tager code B21</div>
            {isTransactionSuccessful17to21 && (
              <div className="tick-icon">
                <i
                  className="fas fa-check-circle"
                  style={{ color: "#3385c9", fontSize: "30px" }}></i>
              </div>
            )}
          </div>
          <div className="vertical-bank-item3">
            {/* Bank 11 Label */}
            <div className="bank-label222">Bank 22</div>{" "}
            {/* Added Bank 9 label here */}
            <div className="tag-label192">Tager code B22</div>
            {isTransactionSuccessful17to22 && (
              <div className="tick-icon">
                <i
                  className="fas fa-check-circle"
                  style={{ color: "#3385c9", fontSize: "30px" }}></i>
              </div>
            )}
          </div>
          <div className="vertical-bank-item3">
            {/* Bank 11 Label */}
            <div className="bank-label233">Bank 23</div>{" "}
            {/* Added Bank 9 label here */}
            <div className="tag-label203">Tager code B23</div>
            {isTransactionSuccessful18to23 && (
              <div className="tick-icon">
                <i
                  className="fas fa-check-circle"
                  style={{ color: "#3385c9", fontSize: "30px" }}></i>
              </div>
            )}
          </div>
          <div className="vertical-bank-item3">
            {/* Bank 14 Label */}
            <div className="bank-label244">Bank 24</div>{" "}
            {/* Added Bank 9 label here */}
            <div className="tag-label214">Tager code B24</div>
            {isTransactionSuccessful18to24 && (
              <div className="tick-icon">
                <i
                  className="fas fa-check-circle"
                  style={{ color: "#3385c9", fontSize: "30px" }}></i>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BankTransfer15to24;
